import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Layout from "../components/layouts/Layout";

const DeltaRoute = ({ children }) => {
  const [isAutonomo, setIsAutonomo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const roleSelected = JSON.parse(localStorage.getItem('role') || "[]");

    if (roleSelected.includes("autonomo")) {
      setIsAutonomo(true);
    } else {
      setIsAutonomo(false);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return null;
  }

  if (!isAutonomo) {
    return <Navigate to="/404" replace />;
  }

  return (
    <>
      {children}
    </>
  );
};

export default DeltaRoute;
